import { render, staticRenderFns } from "./UserProfileAbout.vue?vue&type=template&id=5081ff2a&scoped=true&"
import script from "./UserProfileAbout.vue?vue&type=script&lang=js&"
export * from "./UserProfileAbout.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileAbout.vue?vue&type=style&index=0&id=5081ff2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081ff2a",
  null
  
)

export default component.exports